export default __webpack_public_path__ + "static/media/ic-overall.0b95a2ec.svg";